import React from 'react';
import {motion} from 'framer-motion';
import {assetsApi} from '../../lib/assetsApi';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const {FiCheck,FiImage,FiDroplet,FiLoader}=FiIcons;

export default function AssetSelector({assets, type, selectedId, onSelect, title}) {
  const [assetUrls, setAssetUrls]=React.useState({});
  const [loading, setLoading]=React.useState({});
  
  const handleAssetClick=async (asset)=> {
    onSelect(asset);
  };

  // Load all asset thumbnails
  React.useEffect(()=> {
    const loadAssetThumbnails=async ()=> {
      const urls={};
      const loadingStates={};
      
      for (const asset of assets) {
        if (asset.dropbox_path) {
          loadingStates[asset.id]=true;
        }
      }
      
      setLoading(loadingStates);
      
      for (const asset of assets) {
        if (asset.dropbox_path) {
          try {
            const url=await assetsApi.getAssetUrl(asset.dropbox_path);
            urls[asset.id]=url;
          } catch (error) {
            console.warn(`Failed to load ${type} thumbnail:`, error);
          } finally {
            setLoading(prev=> ({...prev, [asset.id]: false}));
          }
        }
      }
      
      setAssetUrls(urls);
    };
    
    if (assets && assets.length > 0) {
      loadAssetThumbnails();
    }
  }, [assets, type]);

  if (!assets || assets.length===0) {
    return (
      <div className="border-2 border-dashed border-gray-300 rounded-lg p-8 text-center">
        <SafeIcon icon={type==='logo' ? FiImage : FiDroplet} className="w-12 h-12 text-gray-300 mx-auto mb-3" />
        <p className="text-gray-500 text-sm">No {title.toLowerCase()} uploaded</p>
      </div>
    );
  }

  return (
    <div>
      <h4 className="text-sm font-medium text-gray-700 mb-3">{title}</h4>
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3">
        {assets.map((asset)=> (
          <motion.div
            key={asset.id}
            whileHover={{scale: 1.02}}
            whileTap={{scale: 0.98}}
            onClick={()=> handleAssetClick(asset)}
            className={`relative cursor-pointer rounded-lg border-2 transition-all ${
              selectedId===asset.id 
                ? 'border-blue-500 bg-blue-50 ring-2 ring-blue-200' 
                : 'border-gray-200 bg-white hover:border-gray-300'
            }`}
          >
            <div className="p-3">
              {loading[asset.id] ? (
                <div className="w-full h-20 bg-gray-100 rounded flex items-center justify-center">
                  <SafeIcon icon={FiLoader} className="w-4 h-4 animate-spin text-gray-400" />
                </div>
              ) : assetUrls[asset.id] ? (
                <img 
                  src={assetUrls[asset.id]} 
                  alt={asset.name}
                  className="w-full h-20 object-contain rounded bg-gray-50"
                  onError={(e)=> {
                    e.target.style.display='none';
                    e.target.nextSibling.style.display='flex';
                  }}
                />
              ) : (
                <div className="w-full h-20 bg-gray-100 rounded flex items-center justify-center">
                  <SafeIcon icon={type==='logo' ? FiImage : FiDroplet} className="w-6 h-6 text-gray-400" />
                </div>
              )}
              <div className="mt-2">
                <p className="text-xs font-medium text-gray-900 truncate">{asset.name}</p>
                <p className="text-xs text-gray-500">
                  {(asset.size / 1024 / 1024).toFixed(1)} MB
                </p>
              </div>
            </div>
            
            {selectedId===asset.id && (
              <div className="absolute top-2 right-2 bg-blue-600 text-white rounded-full p-1">
                <SafeIcon icon={FiCheck} className="w-3 h-3" />
              </div>
            )}
          </motion.div>
        ))}
      </div>
    </div>
  );
}